<template>
  <md-dialog :md-active.sync="dialogVisible" class="change-type-dialog">
    <md-dialog-title class="dialog-title">
      <md-icon class="title-icon">fingerprint</md-icon>
      تغيير نوع البصمة
    </md-dialog-title>
    <md-dialog-content class="dialog-content">
      <div class="content-container">
        <div class="current-type-section">
          <md-icon class="info-icon">info</md-icon>

          <span v-if="selectedItem" class="current-type-text">
            النوع الحالي:
            <md-content
              class="md-primary"
              style="border-radius: 10px; padding: 5px 10px"
            >
              {{ selectedItem.type }}</md-content
            >
          </span>
        </div>

        <div class="divier"></div>

        <div class="selection-section">
          <h4 class="selection-title">
            <md-icon class="selection-icon">radio_button_checked</md-icon>
            اختر النوع الجديد:
          </h4>

          <div class="radio-group">
            <div class="radio-option" @click="newSignType = 1">
              <md-radio
                v-model="newSignType"
                :value="1"
                class="md-primary custom-radio"
              >
                <div class="radio-content">
                  <span class="radio-text">دخول</span>
                  <md-icon class="radio-icon entry-icon">login</md-icon>
                </div>
              </md-radio>
            </div>

            <div class="radio-option" @click="newSignType = 2">
              <md-radio
                v-model="newSignType"
                :value="2"
                class="md-accent custom-radio"
              >
                <div class="radio-content">
                  <span class="radio-text">خروج</span>
                  <md-icon class="radio-icon exit-icon">logout</md-icon>
                </div>
              </md-radio>
            </div>
          </div>
          <div dir="rtl" class="mt-25">
            <md-field>
              <label>حالة البصمة</label>

              <md-select v-model="status">
                <md-option :value="1">معتمدة</md-option>
                <md-option :value="2">تجاهل</md-option>
                <!-- <md-option value="Confirmed">معتمدة</md-option> -->
                <!-- <md-option value="UnConfirmed">تجاهل</md-option> -->
              </md-select>
            </md-field>
          </div>
          <div dir="rtl" class="mt-25">
            <label>اسم الدوام</label>
            <model-list-select
              class="input-must-rtl"
              :list="shiftList"
              v-model="shiftId"
              option-value="id"
              option-text="name"
            />
          </div>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions class="dialog-actions">
      <div class="action-buttons">
        <md-button class="md-accent cancel-btn" @click="closeChangeTypeDialog">
          <md-icon class="btn-icon">close</md-icon>
          <span class="btn-text">إلغاء</span>
        </md-button>
        <md-button class="md-primary confirm-btn" @click="confirmChange">
          <md-icon class="btn-icon">check</md-icon>
          <span class="btn-text">تأكيد</span>
        </md-button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { ModelListSelect } from "vue-search-select";

export default {
  components: {
    ModelListSelect,
  },
  props: {
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
    showChangeTypeDialog: {
      type: Boolean,
      default: false,
    },
    shiftList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showChangeTypeDialog;
      },
      set(value) {
        this.$emit("update:showChangeTypeDialog", value);
      },
    },
  },

  data() {
    return {
      newSignType: 1,
      status: null,
      shiftId: null,
    };
  },
  methods: {
    closeChangeTypeDialog() {
      this.$emit("close-change-type-dialog");
      this.$emit("update:showChangeTypeDialog", false);
      this.newSignType = 1;
      this.status = null;
      this.shiftId = null;
    },
    confirmChange() {
      // إرسال البيانات المحدثة للمكون الأب
      this.$emit("confirm-change", {
        selectedItem: this.selectedItem,
        newSignType: this.newSignType,
        status: this.status,
        shiftId: this.shiftId,
      });
      this.closeChangeTypeDialog();
    },
  },

  watch: {
    selectedItem(newValue, oldValue) {
      if (newValue) {
        this.newSignType = newValue.signType;
        this.status = newValue.status;
        this.shiftId = newValue.shiftId;
      }
    },
  },
};
</script>

<style lang="scss">
/* Dialog Styles */
.change-type-dialog {
  // overflow-y: auto;
  .md-dialog-container {
    min-width: 435px;
  }
  .md-dialog {
    min-width: 580px;
    max-width: 700px;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .dialog-title {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;

    .title-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }

  .dialog-content {
    padding: 30px 24px;
    background: #fafafa;
    // overflow: visible;
  }

  .content-container {
    max-width: 100%;
  }

  .current-type-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;

    .info-icon {
      color: #2196f3;
      margin-right: 12px;
      margin-left: 0;
      font-size: 20px;
    }

    .current-type-text {
      font-size: 16px;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;
      direction: rtl;
      text-align: right;
    }

    .current-type-chip {
      font-weight: 600;
      font-size: 14px;
    }
  }

  .divider {
    height: 2px;
    background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
    margin: 20px 0;
  }

  .selection-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .selection-title {
      display: flex;
      align-items: center;
      margin: 0 0 20px 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
      direction: rtl;
      text-align: right;

      .selection-icon {
        margin-right: 8px;
        margin-left: 0;
        color: #9c27b0;
      }
    }

    .radio-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .radio-option {
      border: 2px solid #e0e0e0;
      border-radius: 8px;
      padding: 16px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        border-color: #2196f3;
        background: #f8f9ff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
      }

      .custom-radio {
        margin: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;

        .radio-content {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 16px;
          font-weight: 500;
          direction: rtl;
          text-align: right;

          .radio-icon {
            font-size: 20px;
          }

          .entry-icon {
            color: #4caf50;
          }

          .exit-icon {
            color: #f44336;
          }

          .radio-text {
            color: #333;
          }
        }
      }

      // Selected state
      &:has(.md-radio.md-checked) {
        border-color: #2196f3;
        background: #e3f2fd;
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.2);
      }
    }
  }

  .dialog-actions {
    padding: 16px 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 0 0 12px 12px;
    border-top: 1px solid #dee2e6;
    justify-content: flex-start;

    .action-buttons {
      display: flex;
      justify-content: center;
      gap: 12px;
      direction: rtl;
      align-items: center;
    }

    .cancel-btn {
      padding: 4px 10px;
      border-radius: 5px;
      font-weight: 500;
      min-width: 65px;
      transition: all 0.2s ease;
      box-shadow: 0 1px 4px rgba(244, 67, 54, 0.2);

      .btn-icon {
        margin-right: 4px;
        margin-left: 0;
        font-size: 14px;
      }

      .btn-text {
        font-size: 11px;
        font-weight: 500;
      }

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(244, 67, 54, 0.25);
      }
    }

    .confirm-btn {
      padding: 4px 12px;
      border-radius: 5px;
      font-weight: 500;
      min-width: 70px;
      transition: all 0.2s ease;
      box-shadow: 0 2px 6px rgba(33, 150, 243, 0.25);

      .btn-icon {
        margin-right: 4px;
        margin-left: 0;
        font-size: 14px;
      }

      .btn-text {
        font-size: 11px;
        font-weight: 500;
      }

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 3px 10px rgba(33, 150, 243, 0.3);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 1px 4px rgba(33, 150, 243, 0.25);
      }
    }
  }
}

// Responsive design
@media (max-width: 768px) {
  .change-type-dialog {
    .md-dialog {
      min-width: 90vw;
      margin: 20px;
    }

    .dialog-content {
      padding: 20px 16px;
    }

    .current-type-section,
    .selection-section {
      padding: 16px;
    }

    .radio-option {
      padding: 12px;
    }
  }
}
</style>
